import { reducerDefaults } from './utils/reducerUtils';
import { CONFERENCE_CALL } from '../actions/utils/actionCases';

export const params = {
	pageName: 'calls',
	itemName: 'call',
	itemId: 'callId',
};

const initialState = reducerDefaults.initialState(params);

export default (state = initialState, action) => {
	switch (action.type) {
		case CONFERENCE_CALL.INITIALIZE:
			return initialState;
		case CONFERENCE_CALL.GET_PAGE:
			return reducerDefaults.getPage(state, action, params);
		case CONFERENCE_CALL.CLEAR_PAGES:
			return reducerDefaults.clearPages(state, params);
		case CONFERENCE_CALL.POST:
			return reducerDefaults.postItem(state, action, params);
		case CONFERENCE_CALL.PUT:
			return reducerDefaults.putItem(state, action, params);
		case CONFERENCE_CALL.DELETE:
			return reducerDefaults.deleteItem(state, action, params);
		case CONFERENCE_CALL.UNSET_ACTIVE:
			return reducerDefaults.unsetActive(state, params);
		default:
			return state;
	}
};
